import { fetcher } from '@commenda/utils';

import { getFilingConductorAnalysisJobPath } from './filing-conductor-analysis-paths';
import {
  FilingConductorAnalysisMutationResult,
  FilingConductorAnalysisStatusResponse,
  SendFilingConductorAnalysisMessageParams,
} from './types';

export async function sendFilingConductorAnalysisMessage({
  jobId,
  message,
}: SendFilingConductorAnalysisMessageParams): Promise<
  FilingConductorAnalysisMutationResult<FilingConductorAnalysisStatusResponse>
> {
  try {
    const response = await fetcher(
      getFilingConductorAnalysisJobPath(jobId, 'messages'),
      { method: 'POST', body: { message } }
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to send message',
        status: response.status,
      };
    }
    return {
      success: true,
      data: json as FilingConductorAnalysisStatusResponse,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to send message',
    };
  }
}
